import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateEventEventIdStatsShareLayoutRoute() {
  return <ModalStack />;
}
